import { render } from "./FilterBloqueados.vue?vue&type=template&id=6507fd62"
import script from "./FilterBloqueados.vue?vue&type=script&lang=js"
export * from "./FilterBloqueados.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__